import React from 'react';
import './Security.scss';
import SecurityImage from '../../assets/SecurityImage.png';
import SecurityIcon from '../../assets/SecurityIcon.png';
import PasswordIcon from '../../assets/PasswordIcon.png';
import UnlockIcon from '../../assets/UnlockIcon.png';
import EncryptIcon from '../../assets/EncryptIcon.png';
import DecryptIcon from '../../assets/DecryptIcon.png';

export default function Security() {
  return (
    <div className='security-container'>
      <div className='security-image-container'>
        <img src={SecurityImage} alt="security" />
      </div>
      <div className='security-section'>
        <div className='security-heading-container'>
          <div className='heading-container'>
            <h2>Because security is</h2>
            <h2>Important</h2>
          </div>
          <div className='security-icon-container'>
            <img src={SecurityIcon} alt="secure" />
          </div>
        </div>
        <div className='security-details-container'>
          <div className='row1'>
            <div className='pdf-password-container'>
              <div className='password-icon-container'>
                <img src={PasswordIcon} alt="set pdf password" />
              </div>
              <p>Set Pdf</p>
              <p>Password</p>
            </div>
            <div className='unclock-pdf-container'>
              <div className='unlock-icon-container'>
                <img src={UnlockIcon} alt="unlock pdf" />
              </div>
              <p>Remove Pdf</p>
              <p>Password</p>
            </div>
          </div>
          <div className='row2'>
            <div className='encrypt-pdf-container'>
              <div className='encrypt-icon-container'>
                <img src={EncryptIcon} alt="encrypt pdf" />
              </div>
              <p>Encrypt File</p>
              <p>or Text</p>
            </div>
            <div className='decrypt-pdf-container'>
              <div className='decrypt-icon-container'>
                <img src={DecryptIcon} alt="decrypt pdf" />
              </div>
              <p>Decrypt File</p>
              <p>or Text</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
